import React, { useRef, useState } from 'react';
import Navbar from '../NavBar/NavBar';
import Footer from '../Footer/Footer'
import emailjs from '@emailjs/browser';
import blob from './blob.svg'
import { Helmet } from '../../seo/Helmet';


const Contact = () => {
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        address: '',   // ✅ new field
        hear: '',
        comments: '',
        services: [], // Initialize as an empty array
    });

    const form = useRef();

    const [disabled, setDisabled] = useState(false)

    const handleInputChange = (event) => {
        const { name, value, type, checked } = event.target;
        if (type === 'checkbox') {
            // Update the array based on checkbox selection
            const updatedServices = checked
                ? [...formData.services, value]
                : formData.services.filter((service) => service !== value);

            setFormData((prevFormData) => ({
                ...prevFormData,
                [name]: updatedServices,
            }));
        } else {
            setFormData((prevFormData) => ({
                ...prevFormData,
                [name]: value,
            }));
        }
        console.log(formData)
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log((formData.services).join(', '))

        // Configure EmailJS parameters
        const serviceId = 'service_1914l26'; // Replace with your EmailJS service ID
        const templateId = 'template_gkj7636'; // Replace with your EmailJS template ID
        const userId = 'xO6LR1sLwDPkq6t_3'; // Replace with your EmailJS user ID

        // Prepare the email data to be sent
        const emailData = {
            from_name: form.current.firstName.value + " " + form.current.lastName.value,
            to_name: 'Client Services Coordination',
            subject: 'Contact Form Submission',
            message_html: `First Name: ${form.current.firstName.value} \n
                     Last Name: ${form.current.lastName.value}\n
                     Email: ${form.current.email.value}\n
                     Phone: ${form.current.phone.value}\n
                     Address: ${form.current.address.value}\n
                     How'd you hear about us: ${form.current.hear.value}\n
                     Comments: ${form.current.comments.value}\n
                     Interested Services: ${formData.services.join(', ')}`,
        };

        // Send the email using EmailJS
        emailjs.send(serviceId, templateId, emailData, userId)
            .then((response) => {
                console.log('Email sent!', response);
                setDisabled(true)
                window.location.href = '/thank-you';
            })
            .catch((error) => {
                console.error('Error sending email:', error);
            });
    };


    return (
        <>
            <Helmet>
                <title>Contact Lennon Window Cleaning | Free Estimate in Seattle Area</title>
                <meta
                    name="description"
                    content="Contact Lennon Window Cleaning for a free estimate on window cleaning, roof and gutter cleaning, pressure washing, or solar panel cleaning in Seattle and surrounding areas."
                />
                <link rel="canonical" href="https://www.lennonwindowcleaning.com/contact" />
                <meta property="og:title" content="Contact Lennon Window Cleaning | Free Estimate in Seattle Area" />
                <meta
                    property="og:description"
                    content="Request a quote for residential exterior cleaning services from Lennon Window Cleaning, serving Seattle and nearby communities."
                />
                <meta property="og:url" content="https://www.lennonwindowcleaning.com/contact" />
                <meta property="og:image" content="https://www.lennonwindowcleaning.com/android-chrome-512x512.png" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Contact Lennon Window Cleaning | Free Estimate in Seattle Area" />
                <meta
                    name="twitter:description"
                    content="Request a quote for residential exterior cleaning services from Lennon Window Cleaning, serving Seattle and nearby communities."
                />
                <meta name="twitter:image" content="https://www.lennonwindowcleaning.com/android-chrome-512x512.png" />
            </Helmet>
            <Navbar />
            <h1 className='contact-h1'>Contact Us</h1>
            <h4 className='contact-h4'>We’d love to hear from you. Let us know how we can help.</h4>

            <div className="contact-container">
                <img alt="blob" className="blob" src={blob} />
                <form className='form-container' ref={form} onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="firstName">First Name:</label>
                        <input type="text" id="firstName" name="firstName" value={formData.firstName} onChange={handleInputChange} required />
                    </div>
                    <div className="form-group">
                        <label htmlFor="lastName">Last Name:</label>
                        <input type="text" id="lastName" name="lastName" value={formData.lastName} onChange={handleInputChange} required />
                    </div>
                    <div className="form-group">
                        <label htmlFor="email">Email:</label>
                        <input type="email" id="email" name="email" value={formData.email} onChange={handleInputChange} required />
                    </div>
                    <div className="form-group">
                        <label htmlFor="phone">Phone Number:</label>
                        <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleInputChange} required />
                    </div>
                    {/* ✅ Address Input */}
                    <div className="form-group">
                        <label htmlFor="address">Address:</label>
                        <input type="text" id="address" name="address" value={formData.address} onChange={handleInputChange} required />
                    </div>
                    <div className="form-group">
                        <label htmlFor="hear">How did you hear about us?</label>
                        <input type="text" id="hear" name="hear" value={formData.hear} onChange={handleInputChange} required />
                    </div>
                    <div className="form-group">
                        <label htmlFor="comments">Additional comments about project:</label>
                        <textarea rows="4" cols="50" id="comments" name="comments" value={formData.comments} onChange={handleInputChange} />
                    </div>

                    <div className="form-group">
                        <label>What services are you interested in?</label>
                        <div className="checkbox-group">
                            <label className='checkbox-flex' htmlFor="windowCleaning">
                                <input type="checkbox" id="windowCleaning" name="services" value="Window Cleaning" checked={formData.services.includes('Window Cleaning')} onChange={handleInputChange} />
                                Window Cleaning
                            </label>
                            <label className='checkbox-flex' htmlFor="roofGutterCleaning">
                                <input type="checkbox" id="roofGutterCleaning" name="services" value="Roof/Gutter Cleaning" checked={formData.services.includes('Roof/Gutter Cleaning')} onChange={handleInputChange} />
                                Roof/Gutter Cleaning
                            </label>
                            <label className='checkbox-flex' htmlFor="pressureWashing">
                                <input type="checkbox" id="pressureWashing" name="services" value="Pressure Washing" checked={formData.services.includes('Pressure Washing')} onChange={handleInputChange} />
                                Pressure Washing
                            </label>
                            <label className='checkbox-flex' htmlFor="solarCleaning">
                                <input type="checkbox" id="solarCleaning" name="services" value="Solar Panel Cleaning" checked={formData.services.includes('Solar Panel Cleaning')} onChange={handleInputChange} />
                                Solar Panel Cleaning
                            </label>
                            <label className='checkbox-flex' htmlFor="xmasLights">
                                <input type="checkbox" id="xmasLights" name="services" value="Christmas Lights" checked={formData.services.includes('Christmas Lights')} onChange={handleInputChange} />
                                Christmas Lights
                            </label>
                        </div>
                    </div>

                    <div className="btn-margin">
                        <input 
                            disabled={disabled}
                            className="send-btn" type="submit" value="Send" />
                    </div>
                </form>
            </div>
            <Footer />
        </>
    );
};

export default Contact;
